import React, { useRef } from 'react';

const FormSectionTabs = ({ tabs, activeTab, onChange, label, idPrefix }) => {
  const tabRefs = useRef({});

  const handleKeyDown = (event, currentIndex) => {
    const keyOffsets = { ArrowLeft: -1, ArrowRight: 1 };
    if (!(event.key in keyOffsets) && event.key !== 'Home' && event.key !== 'End') return;

    event.preventDefault();
    let nextIndex = currentIndex;
    if (event.key === 'Home') nextIndex = 0;
    else if (event.key === 'End') nextIndex = tabs.length - 1;
    else nextIndex = (currentIndex + keyOffsets[event.key] + tabs.length) % tabs.length;

    const nextTab = tabs[nextIndex];
    onChange(nextTab.id);
    window.requestAnimationFrame(() => tabRefs.current[nextTab.id]?.focus());
  };

  return (
  <div className="mb-6 flex overflow-x-auto border-b border-gray-200" role="tablist" aria-label={label}>
    {tabs.map((tab, index) => (
      <button
        key={tab.id}
        ref={element => { tabRefs.current[tab.id] = element; }}
        type="button"
        role="tab"
        aria-selected={activeTab === tab.id}
        aria-controls={`${idPrefix}-${tab.id}-panel`}
        id={`${idPrefix}-${tab.id}-tab`}
        tabIndex={activeTab === tab.id ? 0 : -1}
        onClick={() => onChange(tab.id)}
        onKeyDown={event => handleKeyDown(event, index)}
        className={`min-h-[44px] shrink-0 border-b-2 px-4 py-2 text-sm font-semibold focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-inset ${
          activeTab === tab.id
            ? 'border-blue-600 bg-white text-blue-600'
            : 'border-transparent text-gray-500 hover:bg-gray-50 hover:text-gray-700'
        }`}
      >
        {tab.label}
      </button>
    ))}
  </div>
  );
};

export default FormSectionTabs;
